module.exports = __webpack_public_path__ + "img/-LV19i8tVqAWkZAQuOxx.97f33767.jpg";